import styled from 'styled-components';
import { ColumnDiv } from 'styles/elements/div';

export const Endstate = styled(ColumnDiv)`
  position: relative;
  overflow-y: auto;
`;
